var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.804 10.979) rotate(-10) translate(-11.408 -8.7551)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    y: 2.3363,
    width: 20.163,
    height: 14.857,
    rx: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle2",
    x: 2.0285,
    width: 20.163,
    height: 14.857,
    rx: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m20.591 0.092327c1.1727 0 2.1224 0.9498 2.1224 2.1224v10.612c0 1.1721-0.9498 2.1224-2.1224 2.1224h-1.0384v-1.0612h1.0389c0.5598 0 1.0182-0.43298 1.0586-0.98216l0.0026531-0.079592v-10.612c0-0.5858-0.4749-1.0612-1.0612-1.0612h-15.918c-0.55927 0-1.0177 0.43351-1.058 0.98216l-0.0031837 0.079592v1.0289h-1.0612v-1.0294c0-1.1716 0.95033-2.1224 2.1224-2.1224h15.918l-5.306e-4 5.3061e-4z",
    fill: "#2D2D44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m18.041 2.3363c1.1727 0 2.1224 0.95033 2.1224 2.1224v10.612c0 1.1727-0.9498 2.1224-2.1224 2.1224h-15.918c-1.1727 0-2.1224-0.9498-2.1224-2.1224v-10.612c0-1.1721 0.9498-2.1224 2.1224-2.1224h15.918zm0 1.0612h-15.918c-0.58633 0-1.0612 0.47543-1.0612 1.0612v10.612c0 0.58633 0.4749 1.0612 1.0612 1.0612h15.918c0.58633 0 1.0612-0.4749 1.0612-1.0612v-10.612c0-0.5858-0.4749-1.0612-1.0612-1.0612z",
    fill: "#2D2D44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m6.102 5.52c1.3186 0 2.3878 1.0692 2.3878 2.3878 0 1.3186-1.0692 2.3878-2.3878 2.3878-1.3186 0-2.3878-1.0692-2.3878-2.3878 0-1.3186 1.0692-2.3878 2.3878-2.3878zm0 1.0612c-0.73224 0-1.3265 0.59429-1.3265 1.3265 0 0.73224 0.59429 1.3265 1.3265 1.3265 0.73224 0 1.3265-0.59429 1.3265-1.3265 0-0.73224-0.59429-1.3265-1.3265-1.3265z",
    fill: "#E05C55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle3",
    x: 11.143,
    y: 8.7036,
    width: 6.898,
    height: 1.0612,
    rx: 0.53061,
    fill: "#E05C55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle4",
    x: 11.143,
    y: 6.0506,
    width: 6.898,
    height: 1.0612,
    rx: 0.53061,
    fill: "#E05C55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    x: 11.143,
    y: 11.357,
    width: 4.7755,
    height: 1.0612,
    rx: 0.53061,
    fill: "#E05C55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m6.102 10.826c2.1087 0 3.8347 1.6401 3.9711 3.7143h-1.0644c-0.13424-1.4873-1.3844-2.6531-2.9067-2.6531-1.5229 0-2.7724 1.1658-2.9067 2.6531h-1.0644c0.13637-2.0742 1.8624-3.7143 3.9711-3.7143z",
    fill: "#E05C55"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.087385,
    y: 0.053538,
    width: 23.385,
    height: 17.231,
    rx: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(4.7397 12.939) rotate(-45) translate(-4.7397 -12.939)",
    points: "-0.18338 12.323 9.6628 12.323 9.6628 13.554 -0.18338 13.554",
    fill: "#2D2D44"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.bf599040ca60bba65f89a18b70cf081d.svg";
export { ForwardRef as ReactComponent };